import classNames from 'classnames';
import {Link} from "react-router-dom";
import {updateReportStatus} from "../../../hooks/useEventProgram";

export default function SectionProgram(
    {
        id,
        sections,
        reports,
        dispatch,
        isUserSelectedOnly = false
    }
) {
    return Object.values(sections).map(section => {
        const elements = Object.values(section.elements);
        let elementsToShow = elements;

        if (isUserSelectedOnly) {
            elementsToShow = elements.filter(element => {
                return element.conferenceReport && reports[element.conferenceReport.id].isUserSelected;
            });

            if (!elementsToShow.length) {
                return null;
            }
        }

        return (
            <div className={classNames("sections-conference", {"no-schedule-block": !elementsToShow.length})}>
                <div className="row">
                    <h3>{section.name}</h3>
                    <p className="time-section">
                        {
                            (!!section.timeStart && !!section.timeEnd) ?
                                <>{section.timeStart} - {section.timeEnd} </> :
                                !!section.timeStart ? <>{section.timeStart}</> :
                                    section.timeEnd ? <>{section.timeEnd}</> : null
                        }
                    </p>
                </div>
                {
                    elementsToShow.map(element => {
                        const report = element.conferenceReport ? reports[element.conferenceReport.id] : null;

                        return (
                            <div className="schedule-block">
                                <div className="status-block">
                                    {
                                        !!element && !!report &&
                                        <i
                                            className={classNames({"icon-plus": !report.isUserSelected, "icon-done": report.isUserSelected})}
                                            onClick={
                                                report.isUserSelected ?
                                                    () => updateReportStatus(id, element.id, report.id, dispatch, 'DELETE') :
                                                    () => updateReportStatus(id, element.id, report.id, dispatch, 'POST')
                                                    }
                                        />
                                    }
                                </div>
                                <div className="information-block">
                                    <p className="time">
                                        {
                                            (!!element.timeStart && !!element.timeEnd) ?
                                            <>{element.timeStart} - {element.timeEnd} </> :
                                            !!element.timeStart ? <>{element.timeStart}</> :
                                            element.timeEnd ? <>{element.timeEnd}</> : null
                                        }
                                    </p>
                                    {
                                        !!report ?
                                            <Link to={`/conference/${id}/reports/${report.id}`} className="name">
                                                { report.name }
                                            </Link> :
                                            <p className="name">
                                                { element.name }
                                            </p>
                                    }

                                    {
                                        !!report &&
                                        <p className="authors">
                                            {
                                                report.authors.map((author, index) => {
                                                    return (
                                                        <>
                                                            <Link className={'author-span'} to={`/conference/${id}/speakers/${author.id}`}>
                                                            { author.lastName } { author.firstName } { author.middleName }
                                                            </Link>
                                                            {
                                                                report.authors.length > 1 && report.authors.length !== index + 1 && ', '
                                                            }
                                                        </>
                                                    );
                                                })
                                            }
                                        </p>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    })
}
